module.exports = __webpack_public_path__ + "static/media/nurline_logo.61a49f38.png";